// Redux Form
import { SubmissionError } from 'redux-form';

// Fetch request
import fetch from '../../core/fetch';

// Locale
import messages from '../../locale/messages';


// Redux Action
import { getListingData } from '../../actions/getListing';
import { manageListingSteps } from '../../actions/manageListingSteps';
import { getListingFieldsValues } from '../../actions/getListingFieldsValues';
import { setLoaderStart, setLoaderComplete } from '../../actions/loader/loader';

// For Redirect
import history from '../../core/history';

async function update(values, dispatch, props = {}) {

  let bedTypes = JSON.stringify(values.bedTypes);
  let variables = Object.assign({}, values, { bedTypes });
  variables.id = Number(props.listId || values.id);
  if (!Number.isInteger(variables.id) || variables.id <= 0) {
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }
  if (props.formPage === 'amenities') {
    variables = { id: variables.id };
    ['amenities', 'safetyAmenities'].forEach(fieldName => {
      if (Array.isArray(values[fieldName])) {
        variables[fieldName] = values[fieldName].map(Number);
      }
    });
  }
  ['roomType', 'houseType', 'buildingSize', 'bathroomType'].forEach(fieldName => {
    if (variables[fieldName] !== undefined && variables[fieldName] !== null) {
      variables[fieldName] = String(variables[fieldName]);
    }
  });

  dispatch(setLoaderStart('updateListing'));
  const query = `query (
  	$id: Int,
    $roomType:String,
    $houseType:String,
    $residenceType:String,
    $bedrooms:String,
    $buildingSize:String,
    $beds:Int,
    $personCapacity:Int,
    $bathrooms:Float,
    $bathroomType:String,
    $country:String,
    $street:String,
    $buildingName:String,
    $city:String,
    $state:String,
    $zipcode:String,
  	$lat: Float,
  	$lng: Float,
  	$isMapTouched: Boolean,
    $amenities: [Int],
    $safetyAmenities: [Int],
    $spaces: [Int],
    $bedTypes: String,
  ) {
      updateListing (
        id: $id,
        roomType:$roomType,
        houseType:$houseType,
        residenceType: $residenceType,
        bedrooms: $bedrooms,
        buildingSize: $buildingSize
        beds: $beds
        personCapacity: $personCapacity
        bathrooms: $bathrooms
        bathroomType: $bathroomType
        country: $country
        street: $street
        buildingName: $buildingName
        city: $city
        state: $state
        zipcode: $zipcode
        lat: $lat
        lng: $lng
        isMapTouched: $isMapTouched,
        amenities: $amenities,
        safetyAmenities: $safetyAmenities,
        spaces: $spaces,
        bedTypes: $bedTypes,
      ) {
        status
      }
    }`;

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      query: query,
      variables
    }),
    credentials: 'include'
  });

  const result = await resp.json();
  const data = result && result.data;

  if (data && data.updateListing && data.updateListing.status == "success") {
    await dispatch(getListingData(String(variables.id)));
    await dispatch(manageListingSteps(String(variables.id), 1));
    await dispatch(getListingFieldsValues("2", String(variables.id)));
    await dispatch(setLoaderComplete('updateListing'));
    history.push('/become-a-host/' + variables.id + '/home');

  } else if (data && data.updateListing && data.updateListing.status == "notLoggedIn") {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.notLoggedIn });
  } else {
    dispatch(setLoaderComplete('updateListing'));
    throw new SubmissionError({ _error: messages.somethingWentWrong });
  }

}

export default update;
